import {BVDCompanyDTO} from "@modules/onBoarding/infrastructure/dto/BVDCompanyDTO";
import {SearchRequest} from "@modules/onBoarding/domain/SearchRequest";
import {BVDMatchDTO} from "@modules/onBoarding/infrastructure/dto/BVDMatchDTO";

type BVDDataDTO = {
    BVDID: string;
    EUROPEAN_VAT_NUMBER: string;
    bvdMatchDTO: {
        NAME: string;
        NAME_INTERNATIONAL: string;
        ADDRESS: string;
        POSTCODE: string;
        CITY: string;
        COUNTRY: string;
    };
};

type GetBVDCompanyDTOSResponse = {
    bvdDataDTOS: BVDDataDTO[]
}

export class BVDCompanyDao {

    async getCompanies(searchRequest: SearchRequest, serviceLoginUrl: string, serviceLoginApiKey?: string): Promise<BVDCompanyDTO[]> {
        const options: RequestInit = this.buildRequestOptions(serviceLoginApiKey);
        const url: string = this.buildRequestUrl(serviceLoginUrl, searchRequest);

        try {
            return await this.getBVDCompanyDTOsFromApi(url, options);
        } catch (error) {
            return [];
        }
    }

    private buildRequestOptions(serviceLoginApiKey: string): RequestInit {
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        };

        if (serviceLoginApiKey) {
            options.headers['x-api-key'] = serviceLoginApiKey;
        }

        return options;
    }

    private buildRequestUrl(serviceLoginUrl: string, searchRequest: SearchRequest): string {
        return serviceLoginUrl + "?" + new URLSearchParams({
            companyId: searchRequest.vatNumber,
            companyName: searchRequest.companyName,
            country: searchRequest.country
        }).toString();
    }

    private async getBVDCompanyDTOsFromApi(url: string, options: RequestInit): Promise<BVDCompanyDTO[]> {
        const response: Response = await fetch(url, options);

        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
        }

        const getBVDCompanyDTOSResponse: GetBVDCompanyDTOSResponse = (await response.json());

        return getBVDCompanyDTOSResponse.bvdDataDTOS?.map((company: BVDDataDTO) =>
            new BVDCompanyDTO(
                company.BVDID,
                company.EUROPEAN_VAT_NUMBER,
                new BVDMatchDTO(
                    company.bvdMatchDTO.NAME,
                    company.bvdMatchDTO.NAME_INTERNATIONAL,
                    company.bvdMatchDTO.ADDRESS,
                    company.bvdMatchDTO.POSTCODE,
                    company.bvdMatchDTO.CITY,
                    company.bvdMatchDTO.COUNTRY,
                )
            )
        );
    }

}
